import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';

@Component({
  selector: 'app-not-enough-alert',
  templateUrl: './not-enough-alert.component.html',
  styleUrls: ['./not-enough-alert.component.scss']
})
export class NotEnoughAlertComponent implements OnInit {

  constructor(
    public dialogRef: MatDialogRef<NotEnoughAlertComponent>,
    @Inject(MAT_DIALOG_DATA) public message: string,
  ) {
    dialogRef.disableClose = false;
  }

  ngOnInit() {
  }

  onNoClick() {
    // this.dataService.setCloseDialogOutOfContractQuantity(true);
    this.dialogRef.close();
  }

}
